import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ViewCourses from './pages/viewCourses/ViewCourses'
import CreateCourse from './pages/createCourse/CreateCourse'
import EditCourse from './pages/editCourse/EditCourse'
import CourseDetail from './pages/viewCourses/CourseDetail'


const Courses = () => {
  return (
    <div>
        <Routes>
            <Route path="/" element={<ViewCourses />} />
            <Route path="/create" element={<CreateCourse />} />
            <Route path="/edit/:id" element={<EditCourse />} />
            <Route path="/view/:id" element={<CourseDetail />} />
        </Routes>
    </div>
  )
}

export default Courses